import * as React from "react"
import { Helmet } from "react-helmet"

export default function Seo({ seo, pageSeo }) {
  const {
    metaTitle,
    metaDesc,
    shareGraphic,
    favicon,
    faviconLegacy,
    touchIcon,
    title,
  } = seo

  return (
    <Helmet
      htmlAttributes={{
        lang: "en-us",
      }}
    >
      <meta charSet="utf-8" />
      {/* <title>
        {metaTitle && metaTitle + " - "}{" "}
        {pageSeo.metaTitle ? pageSeo.metaTitle : pageSeo.title}
      </title> */}

      <title>
        {metaTitle} - {pageSeo.metaTitle ? pageSeo.metaTitle : metaTitle}
      </title>

      {pageSeo.metaDesc ? (
        <meta
          name="description"
          property="og:description"
          content={pageSeo.metaDesc}
        />
      ) : (
        <meta name="description" property="og:description" content={metaDesc} />
      )}

      {pageSeo.metaTitle ? (
        <meta property="og:title" content={pageSeo.metaTitle} />
      ) : (
        <meta property="og:title" content={metaTitle} />
      )}

      {pageSeo.shareGraphic ? (
        <meta property="og:image" content={pageSeo.shareGraphic.asset.url} />
      ) : (
        <meta property="og:image" content={shareGraphic.asset.url} />
      )}
      <meta name="twitter:card" content="summary" />
      {pageSeo.metaTitle ? (
        <meta name="twitter:title" content={pageSeo.metaTitle} />
      ) : (
        <meta name="twitter:title" content={metaTitle} />
      )}
      {pageSeo.metaDesc ? (
        <meta name="twitter:description" content={pageSeo.metaDesc} />
      ) : (
        <meta name="twitter:description" content={metaDesc} />
      )}
      {pageSeo.shareGraphic ? (
        <meta name="twitter:image" content={pageSeo.shareGraphic.asset.url} />
      ) : (
        <meta name="twitter:image" content={shareGraphic.asset.url} />
      )}

      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=ac7310ea-b6ef-43cf-8218-f2bc0dfa4d9b"
      >
        {" "}
      </script>
    </Helmet>
  )
}
